import { createI18n } from 'vue-i18n';
import VueI18n from 'vue-i18n'

function loadLocaleMessages () {
	const locales = require.context('@/i18n/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
	const messages = {}
	locales.keys().forEach(key => {
		const matched = key.match(/([A-Za-z0-9-_]+)\./i)
		if (matched && matched.length > 1) {
			const locale = matched[1]
			messages[locale] = locales(key)
		}
	})
	return messages
}

let locale = process.env.VUE_APP_I18N_LOCALE || 'fr' 
let locfallbackLocaleale = process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'fr'
const i18n = createI18n({
	locale: locale,
	fallbackLocale: locfallbackLocaleale,
	messages: loadLocaleMessages(),
	legacy: false, // set to false to use the Composition API
});

export default i18n;